import { inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EulaDialogComponent } from 'src/app/components/eula/eula-dialog/eula-dialog.component';
import { EulaService } from 'src/app/services/eula.service';

export const eulaAcceptedGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot
): Observable<boolean> => {
    const eulaService = inject(EulaService);
    const matDialog = inject(MatDialog);

    const nonBlockingGuards = route.data.nonBlockingGuards as boolean;
    const eulaCheck = eulaService.isEulaConfirmCurrent().pipe(
        tap((accepted) => {
            if (!accepted) {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                matDialog.open(EulaDialogComponent, dialogConfig);
            }
        })
    );
    if (nonBlockingGuards) {
        eulaCheck.subscribe();
        return of(true);
    } else {
        return eulaCheck;
    }
};
